import { useEffect } from 'react'
import { useProductAnalyticsContext } from 'features/product-analytics/ProductAnalyticsProvider'
import { isTestEnv } from 'constants/Utils.constants'

export default function useReloadTracker() {
  const { trackEvent } = useProductAnalyticsContext()
  useEffect(() => {
    if (!isTestEnv && isReloadEvent()) {
      trackEvent({ type: 'PageReloaded' })
    }
  }, [])
}

function isNavigationPerformanceEntry(entry: PerformanceEntry): entry is PerformanceNavigationTiming {
  return entry.entryType === 'navigation'
}

function isReloadPerformanceEntry(entry: PerformanceEntry) {
  if (isNavigationPerformanceEntry(entry)) {
    return entry.type === 'reload'
  }

  return false
}

function isReloadEvent() {
  const navEntries = 'getEntriesByType' in window.performance ? window.performance.getEntriesByType('navigation') : null

  return (
    (Array.isArray(navEntries) && navEntries.some(isReloadPerformanceEntry)) ||
    window.performance.navigation?.type === PerformanceNavigation.TYPE_RELOAD
  )
}
